import {ACTION_CODE} from './_actionCode';
import {DashboardService} from '../../../services';
import {ErrorModel, ResultModel} from '../../../models';
import {LoggerService} from '../../../services';
const FUNCTION_CODE = 'GET_BILLING';

export async function getBilling(userData: Record<string, any>, params: Record<string, any>) {
    try {
        LoggerService.logInfo('Action - getBilling - Start');

        const getBilling =
            await DashboardService.OfficeManagerService.getBilling(userData, params);

        LoggerService.logInfo('Action - getBilling - End - Success');

        return ResultModel.newSuccessResult(getBilling);
    }
    catch (error) {
        LoggerService.logInfo('Action - getBilling - End - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
